export function extractVin(text) {
  if (!text) return null;
  const clean = text.toUpperCase().replace(/[^A-Z0-9]/g, " ");
  const tokens = clean.split(/\s+/);
  for (const t of tokens) {
    if (/^[A-HJ-NPR-Z0-9]{17}$/.test(t)) return t;
  }
  for (const t of tokens) {
    const fixed = t.replace(/O/g, "0").replace(/[IQ]/g, "1");
    if (/^[A-HJ-NPR-Z0-9]{17}$/.test(fixed)) return fixed;
  }
  const joined = clean.replace(/\s/g, "");
  const m = joined.match(/[A-HJ-NPR-Z0-9]{17}/);
  if (m) return m[0];
  const joinedFixed = joined.replace(/O/g, "0").replace(/[IQ]/g, "1");
  const m2 = joinedFixed.match(/[A-HJ-NPR-Z0-9]{17}/);
  return m2 ? m2[0] : null;
}

// Ruhsat görselinden istemci tarafı OCR (tesseract.js, ucretsiz) ile VIN okuma
export async function ocrVinFromImageFile(file) {
  const { createWorker } = await import("tesseract.js");
  const worker = await createWorker("eng");
  await worker.setParameters({ tessedit_char_whitelist: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789" });
  try {
    const { data } = await worker.recognize(file);
    return extractVin(data.text);
  } finally {
    await worker.terminate();
  }
}
